<template>
  <div class="home">

    <!-- Banner -->
    <hooper :infiniteScroll="true" :wheelControl="false" :autoPlay="true" :playSpeed="6500" :transition="800" :hoverPause="false" style="height: 800px;" >

      <slide v-for="img in carousel" :key="img">
        <img :src="img.gallery_image.url" alt="">
          <h3> {{ img.gallery_image.alt }} </h3> 
      </slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
      <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </hooper>

    <div class="container">
        <h1>Encuentra la casa de tus sueños </h1>
<!--         https://contempothemes.com/wp-real-estate-7/multi-two-demo/
-->    
        <div class="buscador">
          <select  v-model="selectCity" @change="filterCitySelect(selectCity, selectMin, selectMax,selectRooms, selectBath)">
            <option value="España">España</option>
            <option v-for="(city, indice) in filterCity" :key="indice" :value="city" >{{city}}</option>
          </select>

          <select v-model="selectMin" @change="filterCitySelect(selectCity, selectMin, selectMax, selectRooms, selectBath)">
            <option value="0"> Price Min </option>
            <option value="100000">100.000 €</option>
            <option value="150000">150.000 €</option>
            <option value="200000">200.000 €</option>
            <option value="300000">300.000 €</option>
            <option value="500000">500.000 €</option>
            <option value="1000000">1M €</option>
            <option value="2000000">2M €</option>
            <option value="5000000">5M €</option>
            <option value="10000000">10M €</option>
          </select>

          <select v-model="selectMax" @change="filterCitySelect(selectCity, selectMin, selectMax, selectRooms, selectBath)">
            <option value="100000000"> Price Max </option>
            <option value="100000">100.000 €</option>
            <option value="150000">150.000 €</option>
            <option value="200000">200.000 €</option>
            <option value="300000">300.000 €</option>
            <option value="500000">500.000 €</option>
            <option value="1000000">1M €</option>
            <option value="2000000">2M €</option>
            <option value="5000000">5M €</option>
            <option value="10000000">10M €</option>
          </select>

          <select v-model="selectRooms" @change="filterCitySelect(selectCity, selectMin, selectMax, selectRooms, selectBath)">
            <option value="0">Min Habitaciones</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4 o +</option>
          </select>

          <select v-model="selectBath" @change="filterCitySelect(selectCity, selectMin, selectMax, selectRooms, selectBath)">
            <option value="0"> Min Baños </option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4 o +</option>
          </select>


        </div>
          

         <div class="houses--container">
          <!-- Todos -->
          <div v-if="selectCity == 'España'" class="houses--container">
            <div  class="house--container" v-for="casa in filterCasas" :key="casa.id">
              <router-link  class="blog--container--more" v-bind:to="'/house/' + casa.uid">
                <div class="house--img" >
                  <img :src="casa.img.url" :alt="casa.img.alt">
                </div>
                <div v-if="casa.tag == 'Rebajado'" class="rebajado">REBAJADO </div>
                <div v-if="casa.tag == 'Nuevo'" class="nuevo">NUEVO </div>
                <div class="house--info">

                  <div class="house--content">
                    <div class="house--content--title">{{casa.name}} - {{casa.city}}</div>
                    <!-- <div class="house--content--zone">{{casa.localidad}}</div> -->
                  </div>

                  <div class="house--content--info">
                    <div >
                      <div class="house--content--price">{{casa.price}} €</div>
                    </div>

                    <div class="house--icons">
                      <div class="bed">
                        {{casa.bedrooms}}<svg  height="20px" width="20px" fill="#000000" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background: new 0 0 100 100;" xml:space="preserve"><switch><foreignObject requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" x="0" y="0" width="1" height="1"/><g i:extraneous="self"><path d="M83.2,45.6V24.8c0-6.2-5-11.2-11.2-11.2H28c-6.2,0-11.2,5-11.2,11.2v20.9c-8.2,1.9-14.3,9.3-14.3,18v19.3    c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5v-5.9h80.9v5.9c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5V63.7C97.5,54.9,91.4,47.6,83.2,45.6    z M28,20.6h44c2.3,0,4.2,1.9,4.2,4.2v20.3h-9V34.3c0-3.5-2.8-6.3-6.3-6.3H39.2c-3.5,0-6.3,2.9-6.3,6.3v10.8h-9V24.8    C23.8,22.5,25.7,20.6,28,20.6z M60.1,45.1H39.9V35h20.2V45.1z M9.5,70v-6.4c0-6.3,5.2-11.5,11.5-11.5H79c6.3,0,11.5,5.2,11.5,11.5    V70H9.5z"/></g></switch></svg>
                      </div>
                      <div class="bath">
                        {{casa.bathrooms}}<svg xmlns="http://www.w3.org/2000/svg" height="20px" width="20px" fill="#000000" viewBox="0 0 32 32" x="0px" y="0px"><title>bath,bathroom,bathtub,shower,curtains,bathing,</title><g data-name="bath,bathroom,bathtub,shower,curtains,bathing,"><path d="M23,27H9a5,5,0,0,1-5-5V18a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v4A5,5,0,0,1,23,27ZM6,19v3a3,3,0,0,0,3,3H23a3,3,0,0,0,3-3V19Z"/><rect x="8" y="25" width="3" height="3" rx="1"/><rect x="21" y="25" width="3" height="3" rx="1"/><path d="M7,19a1,1,0,0,1-1-1V7.5a4.5,4.5,0,0,1,9,0V8.9a1,1,0,0,1-2,0V7.5a2.5,2.5,0,0,0-5,0V18A1,1,0,0,1,7,19Z"/><path d="M16,10H12a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z"/></g></svg>              </div>
                      <div class="area">
                        {{casa.area}} m² <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="20px" width="20px" fill="#000000" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background: new 0 0 100 100;" xml:space="preserve"><g><g><g><g><path d="M89.6,83.7H36.1c-0.8,0-1.5-0.7-1.5-1.5V28.7c0-0.6,0.4-1.2,0.9-1.4c0.6-0.2,1.2-0.1,1.6,0.3l53.5,53.5      c0.4,0.4,0.6,1.1,0.3,1.6S90.2,83.7,89.6,83.7z M37.6,80.7H86L37.6,32.3V80.7z"/></g><g><path d="M41.5,51h-4.6c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h4.6c0.8,0,1.5,0.7,1.5,1.5S42.3,51,41.5,51z"/></g><g><path d="M41.5,67.7h-4.6c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h4.6c0.8,0,1.5,0.7,1.5,1.5S42.3,67.7,41.5,67.7z"/></g><g><path d="M46.1,60h-9.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h9.2c0.8,0,1.5,0.7,1.5,1.5S46.9,60,46.1,60z"/></g><g><path d="M46.1,75.8h-9.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h9.2c0.8,0,1.5,0.7,1.5,1.5S46.9,75.8,46.1,75.8z"/></g></g><g><g><path d="M14.3,20.2h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,20.2,14.3,20.2z"/></g><g><g><path d="M28.8,83.7H10.4c-0.8,0-1.5-0.7-1.5-1.5V12.5c0-0.8,0.7-1.5,1.5-1.5h18.4c0.8,0,1.5,0.7,1.5,1.5v69.6       C30.3,83,29.6,83.7,28.8,83.7z M11.9,80.7h15.4V14H11.9V80.7z"/></g><g><path d="M17.8,25.1h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,25.1,17.8,25.1z"/></g><g><path d="M14.3,30.7h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,30.7,14.3,30.7z"/></g><g><path d="M17.8,35.6h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,35.6,17.8,35.6z"/></g><g><path d="M14.3,41.3h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,41.3,14.3,41.3z"/></g><g><path d="M17.8,46.2h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,46.2,17.8,46.2z"/></g><g><path d="M14.3,51.8h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,51.8,14.3,51.8z"/></g><g><path d="M17.8,56.7h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,56.7,17.8,56.7z"/></g><g><path d="M14.3,62.4h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,62.4,14.3,62.4z"/></g><g><path d="M17.8,67.3h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,67.3,17.8,67.3z"/></g><g><path d="M14.3,73h-3.9c-0.8,0-1.5-0.7-1.5-1.5S9.5,70,10.4,70h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,73,14.3,73z"/></g></g></g></g></g></svg>
                      </div>

                    </div>
                  </div>
                </div>
              </router-link>
            </div>   
          </div>
           
          <!-- Filtrado -->
          <div v-if="selectCity != 'España'" class="houses--container">
            <div class="house--container" v-for="casa in filterCasas" :key="casa.id">

              <router-link  class="blog--container--more" v-bind:to="'/house/' + casa.uid">
                <div class="house--img" >
                  <img :src="casa.img.url" :alt="casa.img.alt">
                </div>
                <div class="house--info">

                  <div class="house--content">
                    <div class="house--content--title">{{casa.name}} - {{casa.city}}</div>
                    <!-- <div class="house--content--zone">{{casa.localidad}}</div> -->
                  </div>

                  <div class="house--content--info">
                    <div >
                      <div class="house--content--price">{{casa.price}} €</div>
                    </div>

                    <div class="house--icons">
                      <div class="bed">
                        {{casa.bedrooms}}<svg  height="20px" width="20px" fill="#000000" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background: new 0 0 100 100;" xml:space="preserve"><switch><foreignObject requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" x="0" y="0" width="1" height="1"/><g i:extraneous="self"><path d="M83.2,45.6V24.8c0-6.2-5-11.2-11.2-11.2H28c-6.2,0-11.2,5-11.2,11.2v20.9c-8.2,1.9-14.3,9.3-14.3,18v19.3    c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5v-5.9h80.9v5.9c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5V63.7C97.5,54.9,91.4,47.6,83.2,45.6    z M28,20.6h44c2.3,0,4.2,1.9,4.2,4.2v20.3h-9V34.3c0-3.5-2.8-6.3-6.3-6.3H39.2c-3.5,0-6.3,2.9-6.3,6.3v10.8h-9V24.8    C23.8,22.5,25.7,20.6,28,20.6z M60.1,45.1H39.9V35h20.2V45.1z M9.5,70v-6.4c0-6.3,5.2-11.5,11.5-11.5H79c6.3,0,11.5,5.2,11.5,11.5    V70H9.5z"/></g></switch></svg>
                      </div>
                      <div class="bath">
                        {{casa.bathrooms}}<svg xmlns="http://www.w3.org/2000/svg" height="20px" width="20px" fill="#000000" viewBox="0 0 32 32" x="0px" y="0px"><title>bath,bathroom,bathtub,shower,curtains,bathing,</title><g data-name="bath,bathroom,bathtub,shower,curtains,bathing,"><path d="M23,27H9a5,5,0,0,1-5-5V18a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v4A5,5,0,0,1,23,27ZM6,19v3a3,3,0,0,0,3,3H23a3,3,0,0,0,3-3V19Z"/><rect x="8" y="25" width="3" height="3" rx="1"/><rect x="21" y="25" width="3" height="3" rx="1"/><path d="M7,19a1,1,0,0,1-1-1V7.5a4.5,4.5,0,0,1,9,0V8.9a1,1,0,0,1-2,0V7.5a2.5,2.5,0,0,0-5,0V18A1,1,0,0,1,7,19Z"/><path d="M16,10H12a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z"/></g></svg>              </div>
                      <div class="area">
                        {{casa.area}} m² <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="20px" width="20px" fill="#000000" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background: new 0 0 100 100;" xml:space="preserve"><g><g><g><g><path d="M89.6,83.7H36.1c-0.8,0-1.5-0.7-1.5-1.5V28.7c0-0.6,0.4-1.2,0.9-1.4c0.6-0.2,1.2-0.1,1.6,0.3l53.5,53.5      c0.4,0.4,0.6,1.1,0.3,1.6S90.2,83.7,89.6,83.7z M37.6,80.7H86L37.6,32.3V80.7z"/></g><g><path d="M41.5,51h-4.6c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h4.6c0.8,0,1.5,0.7,1.5,1.5S42.3,51,41.5,51z"/></g><g><path d="M41.5,67.7h-4.6c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h4.6c0.8,0,1.5,0.7,1.5,1.5S42.3,67.7,41.5,67.7z"/></g><g><path d="M46.1,60h-9.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h9.2c0.8,0,1.5,0.7,1.5,1.5S46.9,60,46.1,60z"/></g><g><path d="M46.1,75.8h-9.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h9.2c0.8,0,1.5,0.7,1.5,1.5S46.9,75.8,46.1,75.8z"/></g></g><g><g><path d="M14.3,20.2h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,20.2,14.3,20.2z"/></g><g><g><path d="M28.8,83.7H10.4c-0.8,0-1.5-0.7-1.5-1.5V12.5c0-0.8,0.7-1.5,1.5-1.5h18.4c0.8,0,1.5,0.7,1.5,1.5v69.6       C30.3,83,29.6,83.7,28.8,83.7z M11.9,80.7h15.4V14H11.9V80.7z"/></g><g><path d="M17.8,25.1h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,25.1,17.8,25.1z"/></g><g><path d="M14.3,30.7h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,30.7,14.3,30.7z"/></g><g><path d="M17.8,35.6h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,35.6,17.8,35.6z"/></g><g><path d="M14.3,41.3h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,41.3,14.3,41.3z"/></g><g><path d="M17.8,46.2h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,46.2,17.8,46.2z"/></g><g><path d="M14.3,51.8h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,51.8,14.3,51.8z"/></g><g><path d="M17.8,56.7h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,56.7,17.8,56.7z"/></g><g><path d="M14.3,62.4h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,62.4,14.3,62.4z"/></g><g><path d="M17.8,67.3h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,67.3,17.8,67.3z"/></g><g><path d="M14.3,73h-3.9c-0.8,0-1.5-0.7-1.5-1.5S9.5,70,10.4,70h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,73,14.3,73z"/></g></g></g></g></g></svg>
                      </div>

                    </div>
                  </div>
                </div>
              </router-link>
              
            </div>  
          </div> <!-- Fin Filtrado -->
      </div>
    </div>

    <!-- <div v-for="(casa, indix) in casas" :key="indix" >
      <pre>{{casa.coordinates}}</pre>
    </div> -->

    <div style="height: 600px;" class="map--main">
      <l-map
        :zoom="zoom"
        :center="center"
        :options="{scrollWheelZoom:false}"
      >
        <l-tile-layer :url="url"></l-tile-layer>
        <l-marker v-for="(casa, indix) in filterCasas" :key="indix" :lat-lng="[casa.coordinates.latitude, casa.coordinates.longitude]" :icon="icon">
        
          <l-tooltip class="tooltip">
            <div class="info--name--map"> {{casa.name}}</div>
            <div class="info--price--map"> Precio: {{casa.price}} </div>
          </l-tooltip>
        </l-marker>
      </l-map>
    </div>

    <Footer/>
  </div>
</template>

<script>
import Footer from "@/components/Footer"
import { Hooper, Slide, Navigation as HooperNavigation, Pagination as HooperPagination } from 'hooper';
import 'hooper/dist/hooper.css';
// https://baianat.github.io/hooper/getting-started.html

import {LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet';
import { icon } from "leaflet";

export default {
  name: 'Home',
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    Footer,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
  },
  data() {
    return {
      width: window.innerWidth,
      houses: [],
      casas: [],
      filterCasas:[],
      filterCity: [],
      carousel: [],
      selectCity: 'España',
      selectMin: 0,
      selectMax: 100000000,
      selectRooms: 0,
      selectBath: 0,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 6,
      center: [40.0296461,-5.1894404],
      markerLatLng: [],
      bounds: null,
      scrollWheelZoom: false,
      icon: icon({
        iconUrl:'/img/icons/makerpoint.png',
        iconSize:[42, 42],
        iconAnchor:   [16, 37],
      }),
    }
  },
  methods: {
     getContent() {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'houses')
      ).then((response) => {
        // response is the response object, response.results holds the documents
        this.houses = response.results

        //metemos los resultados en casas para pintarlo mas comodamente
        for (const house of this.houses) {
          let params = {
            area: house.data.area,
            bathrooms: house.data.bathrooms,
            bedrooms: house.data.bedrooms,
            img: house.data.imgmain,
            city: house.data.city[0].text,
            coordinates: house.data.coordinates,
            name: house.data.name_house[0].text,
            price: house.data.price,
            built: house.data.year_built,
            uid: house.uid,
            tag : house.data.tag
          }
          this.casas.push(params)
        }

        this.filterCasas = this.casas
        
        //metemos en filterCity todas las ciudades sin que se repitan
        for (const city of this.casas) {
          let ciudad = city.city 


          // Ponemos los cordinadas en la variable para pintarlas
          //this.markerLatLng.push([city.coordinates.latitude, city.coordinates.latitude])
          

          if(!this.filterCity.includes(ciudad)) {
            this.filterCity.push(ciudad)
          }
        }        

        //this.center.push(this.casas[0].coordinates.latitude,this.casas[0].coordinates.longitude)


        // ponemos los puntos a los precios de las casas
        /* for (const house of this.houses) {
          if(house.data.price) {
            house.data.price = new Intl.NumberFormat().format(house.data.price)
          }
        } */
      })

      // banner main
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'banner_home')
      ).then((response) => {
         for (const item of response.results[0].data.body[0].items) {
         //   console.log(item)
            this.carousel.push(item) 
         }
      })
    },
    // Filter Casas
    filterCitySelect(selected, minPrice, maxPrice, rooms, bath) {
      this.selectMin = parseInt(this.selectMin)
      this.selectMax = parseInt(this.selectMax) 
      if(this.selectMax < this.selectMin) {
        this.selectMax = 100000000
      }

      this.filterCasas = this.casas.filter((item) => {
        if(selected != 'España') {
          return item.city == selected && item.price >= minPrice && item.price <= maxPrice && item.bedrooms >= rooms && item.bathrooms >= bath
        } else {
          return item.price >= minPrice && item.price <= maxPrice && item.bedrooms >= rooms && item.bathrooms >= bath
        }
        
      })

    },
    /* filterMinPrice(minPrice) {
      this.filterCasas = this.filterCasas.filter((item) => {
        return item.price >= minPrice
      })
    } */
  },
  created() {
    //this.getContent();
  },
  mounted() {
    this.getContent();
  }

}
</script>

<style scoped>

.hooper img {
    width: 100%;
    height: inherit;
    object-fit: cover;
    object-position: center;
}

.hooper-slide {
    position: relative;
}

.hooper h3 {
    position: absolute;
    bottom: 100px;
    left: 250px;
    width: 350px;
    padding: 80px 50px;
    font-size: 24px;
    color: #717171;
    background: rgb(0 0 0 / 88%);
    border: 2px solid black;
}

.hooper svg.icon {
    width: 50px;
    height: 50px;
    fill: white;
}

</style>